import { Grid } from '@material-ui/core';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { CheckoutButton } from 'src/common/components/checkout-button/checkout-button';
import { LiveWeightArea } from 'src/common/components/live-weight-area/live-weight-area';
import ThemeLogo from 'src/common/components/theme-logo/theme-logo';
import { AppState } from 'src/common/redux/configure-store';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import CheckoutArea from '../checkout-area/checkout-area';
import './../App.css';
import { styles } from './customer-sale-screen-styles';
import TopAdvert from './top-customer-advert';
import { useTranslation } from 'react-i18next';
import NTEPCertification from 'src/home-page/components/home-page-layout/ntep-certification';
import { ThemeContext } from 'src/emerald-theme-provider';

const CustomerSaleScreen: React.FC = (): JSX.Element => {
  const { emeraldTheme } = useContext(ThemeContext);
  const secondaryColor = emeraldTheme?.colorPallete.secondaryColor || '';
  const customerAds = emeraldTheme?.customerDisplay?.customerDisplayContentAds || [];
  const filteredCustomerAds = customerAds.filter(ads => {
    return ads.url;
  });
  const classes = styles({ secondaryColor });
  const { t } = useTranslation();
  const buttonText = t('SCO_AmountDue');
  const total = useSelector((state: AppState): number => state.itemList.total);
  const trainingModeActive = useSelector((state: AppState): boolean => state.posMode.trainingMode);

  return (
    <>
      <Grid
        data-testid='customer-sale-screen'
        container
        className='fullWidth fullHeight'
        direction='column'
      >
        <Grid container className='fullWidth'>
          <Grid
            data-testid='customer-sale-screen-logo-weight-container'
            className={clsx(
              'fullWidth',
              classes.topAreaContainer,
              trainingModeActive ? classes.topAreaContainerTraining : '',
            )}
          >
            <ThemeLogo styles={classes.logo} />
            <Grid item container className={classes.scale}>
              <LiveWeightArea isLeftHanded={false} isSummaryDisabled={false} />
            </Grid>
          </Grid>
        </Grid>

        <Grid container direction='row' className={classes.bottomArea}>
          {trainingModeActive && (
            <TrainingModeWatermark
              supplementalStyles={classes.trainingWaterMark}
              dataTestId='action-window-training-mode-watermark'
            />
          )}
          <Grid
            item
            className={classes.checkoutContainer}
            data-testid='customer-sale-screen-checkout-container'
          >
            <Grid container className={`fullHeight ${classes.itemListContainer}`}>
              <CheckoutArea isCustomerDisplay={true} />
            </Grid>
            <CheckoutButton
              disabled={false}
              total={total}
              currencyCode={'USD'}
              text={buttonText}
              tendering={false}
              drawerAlertIconActive={false}
              buttonHeight='8.33vh'
              isCustomerDisplay={true}
            />
          </Grid>
          <Grid
            item
            className={`fullWidth fullHeight ${classes.imageContainer} ${
              trainingModeActive ? classes.trainingImageContainer : ''
            }`}
            container
            direction='column'
            justifyContent='space-evenly'
          >
            <div className={classes.topAdvert}>
              <TopAdvert />
            </div>
            {filteredCustomerAds.length === 0 && (
              <Grid
                container
                className={classes.customerContainer}
                data-testid='customer-sale-screen-ads-container'
              >
                <Grid className={classes.adDisplay} data-testid='customer-sale-screen-ad-1' />
                <Grid className={classes.adDisplay} data-testid='customer-sale-screen-ad-2' />
              </Grid>
            )}
            {filteredCustomerAds.length === 1 && (
              <Grid className={classes.adDisplay} data-testid='customer-sale-screen-ads-container'>
                <img
                  src={filteredCustomerAds[0].url}
                  className={classes.adImage}
                  data-testid='customer-sale-screen-ad-1'
                ></img>
              </Grid>
            )}
            {filteredCustomerAds.length === 2 && (
              <Grid
                container
                className={classes.customerContainer}
                data-testid='customer-sale-screen-ads-container'
              >
                <Grid className={classes.adDisplay}>
                  <img
                    src={filteredCustomerAds[0].url}
                    className={classes.adImage}
                    data-testid='customer-sale-screen-ad-1'
                  ></img>
                </Grid>
                <div className={classes.divider}></div>
                <Grid className={classes.adDisplay}>
                  <img
                    src={filteredCustomerAds[1].url}
                    className={classes.adImage}
                    data-testid='customer-sale-screen-ad-2'
                  ></img>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      {/* NTEP Trade Scale Certification */}
      <NTEPCertification />
    </>
  );
};
export default CustomerSaleScreen;
